// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const MedusaSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'medusa-attack',
    metadata: {
      frames: {
        'medusa-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-attack-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-attack-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-attack-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-attack-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-attack-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/medusa/attack.png',
        size: {
          w: 768,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'medusa-attack': [
          'medusa-attack-0',
          'medusa-attack-1',
          'medusa-attack-2',
          'medusa-attack-3',
          'medusa-attack-4',
          'medusa-attack-5',
        ],
      },
    },
  },
  {
    name: 'medusa-die',
    metadata: {
      frames: {
        'medusa-die-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-die-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-die-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-die-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-die-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-die-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/medusa/die.png',
        size: {
          w: 768,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'medusa-die': [
          'medusa-die-0',
          'medusa-die-1',
          'medusa-die-2',
          'medusa-die-3',
          'medusa-die-4',
          'medusa-die-5',
        ],
      },
    },
  },
  {
    name: 'medusa-exhaust',
    metadata: {
      frames: {
        'medusa-exhaust-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-exhaust-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/medusa/exhaust.png',
        size: {
          w: 256,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'medusa-exhaust': ['medusa-exhaust-0', 'medusa-exhaust-1'],
      },
    },
  },
  {
    name: 'medusa-idle',
    metadata: {
      frames: {
        'medusa-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-idle-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-idle-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/medusa/idle.png',
        size: {
          w: 384,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'medusa-idle': ['medusa-idle-0', 'medusa-idle-1', 'medusa-idle-2'],
      },
    },
  },
  {
    name: 'medusa-stone',
    metadata: {
      frames: {
        'medusa-stone-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-stone-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-stone-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-stone-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-stone-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-stone-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-stone-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-stone-7': {
          frame: {
            x: 896,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/medusa/stone.png',
        size: {
          w: 1024,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'medusa-stone': [
          'medusa-stone-0',
          'medusa-stone-1',
          'medusa-stone-2',
          'medusa-stone-3',
          'medusa-stone-4',
          'medusa-stone-5',
          'medusa-stone-6',
          'medusa-stone-7',
        ],
      },
    },
  },
  {
    name: 'medusa-run',
    metadata: {
      frames: {
        'medusa-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-run-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-run-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'medusa-run-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/medusa/run.png',
        size: {
          w: 512,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'medusa-run': [
          'medusa-run-0',
          'medusa-run-1',
          'medusa-run-2',
          'medusa-run-3',
        ],
      },
    },
  },
];
